module.exports = __webpack_public_path__ + "images/pages/for_business/sp/img03_f5c0a9405caa3400452141024dc003c4.png";